import Marquee from "react-fast-marquee";
import { Leaf } from "lucide-react";

const ITEMS = [
  "EP-W woningopnames",
  "Tarieven vanaf €139 incl. btw",
  "Registratie in EP-online",
  "Rotterdam en omgeving",
  "Duidelijke communicatie",
  "Persoonlijke begeleiding",
];

export default function TrustMarquee() {
  return (
    <div data-testid="trust-marquee" className="border-y border-black/5 bg-energy-pale py-5" aria-hidden="true">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="font-display text-sm font-medium uppercase tracking-[0.24em] text-energy-deep/70">
              {item}
            </span>
            <Leaf size={14} className="text-primary" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
